import {Box} from 'src/design/atoms/Box';
import {IconArrowsSplit, IconArrowMergeRight} from '@tabler/icons-react';
import React from 'react';
import {Handle, Position} from '@xyflow/react';
import type {PhaseJunctionFlowNodeData} from './nexusGraphTypes';

export const JUNCTION_SIZE = 40;

export const PhaseJunctionNode: React.FC<{data: PhaseJunctionFlowNodeData}> = React.memo(({data}) => {
  const Icon = data.mutuallyExclusiveCompletion ? IconArrowsSplit : IconArrowMergeRight;

  return (
    <>
      <Handle type="target" position={Position.Left} style={{visibility: 'hidden'}} />
      <Box
        style={{
          width: JUNCTION_SIZE,
          height: JUNCTION_SIZE,
          borderRadius: '50%',
          border: '1px solid var(--mantine-color-gray-4)',
          background: 'var(--mantine-color-body)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
        <Icon size={20} color="var(--mantine-color-gray-6)" />
      </Box>
      <Handle type="source" position={Position.Right} style={{visibility: 'hidden'}} />
    </>
  );
});
